<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-container>
        <v-card-title>{{
          title + " (" + $t("config_academic.delete") + ")"
        }}</v-card-title>
        <v-card-text>{{
          $t("config_academic.confirm_delete") + text
        }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="deleteFunction()">
            {{ $t("config_academic.confirm") }}</v-btn
          >
          <v-btn color="error" dark @click="show = false">{{
            $t("config_academic.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    deleteFunction: Function,
    text: String,
    title: String,
    value: Boolean,
  },
  name: "ConfigPaymentDeleteDialog",
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
